module.exports = __webpack_public_path__ + "img/fritschi_2.c54d03e4.jpg";